import { AnchorHTMLAttributes } from 'react'

type MarkdownLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { node?: unknown }

/**
 * Anchor used by MarkdownText for bot-message links.
 * - http(s): open in a new tab — a same-frame nav inside the sandboxed widget is blocked.
 * - tel:/mailto: open in the same context so the device handler (dialer/mail) fires.
 */
export const MarkdownLink = ({ href, children, node: _node, ...props }: MarkdownLinkProps) => {
  const isDeviceHandler = !!href && /^(tel:|mailto:)/i.test(href)
  return (
    <a
      className="font-medium text-primary hover:underline"
      href={href}
      {...(isDeviceHandler ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
      {...props}
    >
      {children}
    </a>
  )
}
